import HttpService from "./http.service";

class AuthService {
  login = async (payload) => {
    const loginEndpoint = "/auth/login";
    return await HttpService.post(loginEndpoint, payload);
  };

  register = async (credentials) => {
    const registerEndpoint = "/auth/register";
    return await HttpService.post(registerEndpoint, credentials);
  };

  logout = async () => {
    const refreshToken = localStorage.getItem("refresh_token");
    const logoutEndpoint = "/auth/logout";
    return await HttpService.post(logoutEndpoint, {
      refresh_token: refreshToken,
    });
  };

  forgotPassword = async (email) => {
    if (typeof email !== "string" || !email.trim()) {
      throw new Error("Email must be a valid string.");
    }

    return HttpService.post("/auth/password-forgot", {
      data: {
        type: "password-forgot",
        attributes: {
          email: email.trim(),
          redirect_url: `${process.env.REACT_APP_URL}/auth/reset-password`,
        },
      },
    });
  };


  resetPassword = async (payload) => {
    return HttpService.post("/auth/password-reset", payload);
  };


  getProfile = async () => {
    const getProfile = "me";
    return await HttpService.get(getProfile);
  };

  updateProfile = async (newInfo) => {
    try {
      const response = await HttpService.patch(`/users/me`, newInfo);
      return response; // ❗ Doğrudan response döndür
    } catch (error) {
      console.error("API error in updateProfile:", error);
      throw error?.response?.data || error;
    }
  };

  refreshToken = async (refreshToken) => {
    try {
      const response = await HttpService.post("/auth/refresh", {
        refresh_token: refreshToken,
      });
      return response;
    } catch (error) {
      console.error("Refresh token error:", error);
      throw error?.response?.data || error;
    }
  };

}

export default new AuthService();
